import React from "react";
import { Popup, Grid } from "semantic-ui-react";
import PropTypes from "prop-types";
import ManuscriptAddBlockItem from "./ManuscriptAddBlockItem";
import Blocks from "./BlockTypes";

/**
 * NewDocumentPopup: props => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Popover component that allows the user to select from a list
 * of file types to create a new document.
 *
 * @param {*} props
 */
const ManuscriptAddBlockMenu = props => {
  const itemsRight = Object.values(Blocks).map(block => (
    <ManuscriptAddBlockItem
      type={block}
      key={block}
      typeSelected={props.createBlock}
    />
  ));
  const itemsLeft = itemsRight.splice(0, Math.floor(itemsRight.length / 2));
  return (
    <Popup
      trigger={props.trigger}
      content={
        <div>
          <Grid>
            <Grid.Row>
              <Grid.Column width={8}>{itemsLeft}</Grid.Column>
              <Grid.Column width={8}>{itemsRight}</Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      }
      hoverable
      on="click"
      className="ed-manuscript-add-block-menu"
      open={props.isOpen}
      onClose={props.onClose}
      onOpen={props.onOpen}
      hideOnScroll
    />
  );
};

ManuscriptAddBlockMenu.propTypes = {
  /**
   * trigger: Node
   * Component, which triggers the popover to open
   * (e.g. a <Button>)
   */
  trigger: PropTypes.node.isRequired,

  /**
   * createBlock: (type) => ()
   * Fired when the user has chosen to create a new block
   */
  createBlock: PropTypes.func.isRequired,

  /**
   * isOpen: Boolean
   * True if the popup should be open
   */
  isOpen: PropTypes.bool.isRequired,

  /**
   * onClose: ()
   * Fired when the popup is dismissed
   */
  onClose: PropTypes.func.isRequired,

  /**
   * onOpen: ()
   * Fired when the popup should open
   */
  onOpen: PropTypes.func.isRequired
};

export default ManuscriptAddBlockMenu;



// WEBPACK FOOTER //
// ./src/modules/editor/manuscript/ManuscriptAddBlockMenu.js